import { render } from "./Model.vue?vue&type=template&id=13bfe97a"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Model.vue?vue&type=style&index=0&id=13bfe97a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__